import { AxiosInstance } from "axios";
import { Track } from "./Track.types";

export const createNewTrack = async (
  axios: AxiosInstance,
  track: Track
): Promise<Track | undefined> => {
  return axios
    .post("tracks/", track)
    .then((res) => res.data)
    .catch((exc) => {
      console.error("Error while saving track", exc);
      return undefined;
    });
};

export const getAllTracks = async (axios: AxiosInstance): Promise<Track[]> => {
  return axios
    .get("tracks/all")
    .then((res) => {
      return res.data;
    })
    .catch((exc) => {
      console.error("Error while saving track", exc);
      return [];
    });
};
export const getAllTracksForUser = async (
  axios: AxiosInstance,
  userId: string
): Promise<Track[]> => {
  return axios
    .get("tracks/all/user", { params: { userId } })
    .then((res) => {
      return res.data;
    })
    .catch((exc) => {
      console.error("Error while saving track", exc);
      return [];
    });
};
